import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function hasNestedObjectListField(fields: SchemaField[], insideList = false): boolean {
  for (const field of fields) {
    if (field.hidden) continue
    if (field.type === 'list') {
      if (insideList && field.fields && field.fields.length > 0) return true
      if (field.fields && hasNestedObjectListField(field.fields, true)) return true
    }
    if ((field.type === 'group' || field.type === 'section') && field.fields) {
      if (hasNestedObjectListField(field.fields, insideList)) return true
    }
    if (field.type === 'tabs' && field.tabs) {
      for (const tab of field.tabs) {
        if (hasNestedObjectListField(tab.fields ?? [], insideList)) return true
      }
    }
  }

  return false
}
